// World map GeoJSON for ECharts - bundled locally to avoid CORS issues
import worldGeoJson from "./world.json";

export async function loadWorldGeoJson(): Promise<any> {
  return worldGeoJson;
}
